module.exports = __webpack_public_path__ + "static/media/nota-fiscal-eletronica.65b8e69a.png";